import { useTranslation } from "react-i18next";
import Modal from "components/commons/Modal";
import SuccessMessage from "components/commons/SuccessMessage";
import { useUpdateCostRefundStatusMutation } from "../api/costRefundApiSlice";
import { useState } from "react";

export default function CostRefundReviewModal({
    refundGuid
}) {

    const [t, i18n] = useTranslation(["global", "absenceReport"])
    const [reason, setReason] = useState("")

    let content

    const [
        sendRequest, {
            isLoading: sendingIsLoading,
            isSuccess: sendingResult }
    ] = useUpdateCostRefundStatusMutation()


    function handleRequestSending() {
        sendRequest({
            guid: refundGuid,
            newStatus: "INCOMPLETE",
            reason: reason
        })
    }

    content =

        <>  {
            false &&
            <SuccessMessage message={t("absenceReport:helper.send_success")} />
        }

            <Modal
                modalId={"reviewModal-dfdf"}
                title={"Richiesta di correzione"}
                buttonLabel={t("action.mark_as_incomplete")}
                buttonIcon={<i className="fa-solid fa-triangle-exclamation"></i>}
                buttonClass={"btn-outline-warning mx-2"}
                locked={false}
                onConfirm={handleRequestSending}
                body={
                    <>
                        <input type="text" className="form-control" placeholder="Motivazione" id="reason" value={reason} onChange={(e) => setReason(e.target.value)} />
                    </>
                }
            />
        </>

    return content
}